import { createAsyncThunk } from "@reduxjs/toolkit";
import { TimelineActions } from "./TimelineSlice";
import { ChildrenStoreData, RootState, TimelineData } from "src/shared/types/src";
import { fetchTimeline, fetchTodayDiary } from "src/shared/services/src";

export const updateTimelineLoader = createAsyncThunk(
    "updateTimelineLoader", async (payload: { timelineLoading: boolean }, { dispatch }) => {
        dispatch(TimelineActions.setTimelineLoading({ isLoading: payload.timelineLoading }));
    }
);

export const updateTimelinePaginatedLoader = createAsyncThunk(
    "updateTimelinePaginatedLoader", async (payload: { paginatedLoading: boolean }, { dispatch }) => {
        dispatch(TimelineActions.setTimelinePaginatedLoading({ paginatedLoading: payload.paginatedLoading }));
    }
);

export const fetchTimelineData = createAsyncThunk(
    'fetchTimeline',
    async ({ page, child, filterObj }: { page: number, child: ChildrenStoreData, filterObj?: any }, { dispatch, rejectWithValue }) => {
        try {
            if (page === 1) {
                await dispatch(TimelineActions.resetTimelineState());
                await dispatch(updateTimelineLoader({ timelineLoading: true }));
            }
            else await dispatch(updateTimelinePaginatedLoader({ paginatedLoading: true }));
            // console.log("filterObj in handler : ", filterObj);
            const response = await fetchTimeline({ page, child, filterObj });
            // console.log("response from timeline :", JSON.stringify(response, null, 2));
            if (response && Object.keys(response).length > 0)
                await dispatch(TimelineActions.appendTimeLineData({ timeline: response.timeline, pagination: response.pagination }));
        } catch (error: any) {
            console.log("error in timeline api : ", error.response);
            return rejectWithValue(error)
            // await dispatch(TimelineActions.resetTimelineState());
        } finally {
            dispatch(updateTimelineLoader({ timelineLoading: false }));
            dispatch(updateTimelinePaginatedLoader({ paginatedLoading: false }));
        }
    }
);

export const fetchTodayDiaryData = createAsyncThunk(
    'fetchTodayDiaryData',
    async ({ child }: { child: ChildrenStoreData }, { dispatch }) => {
        try {
            await dispatch(TimelineActions.resetTodayDiaryState());
            const response = await fetchTodayDiary({ child });
            await dispatch(setTodayDiary({ timeLineData: response?.timeline || [] }));
        } catch (error: any) {
            dispatch(TimelineActions.resetTodayDiaryState());
        }
    }
);

export const setTodayDiary = createAsyncThunk(
    "setTodayDiary", async (payload: { timeLineData: TimelineData[] }, { dispatch }) => {
        dispatch(TimelineActions.setTodayDiary({ timelineData: payload?.timeLineData }));
    }
);

export const fetchTimelineWithFiltersFromState = createAsyncThunk(
    'fetchTimelineWithFiltersFromState',
    async ({ child }: { child: ChildrenStoreData }, { dispatch, getState }) => {
        try {
            const { activityTypes, from, to, isFilterApplied } = (getState() as RootState).timeline?.filters || {};
            let filterObj = {} as any;
            // send filters to api
            if (isFilterApplied) {
                filterObj = {
                    activityType: activityTypes.join(','),
                    from,
                    to
                };
                if (!activityTypes.length) delete filterObj['activityType'];
                if (!from) delete filterObj['from'];
                if (!to) delete filterObj['to'];
            }
            await dispatch(fetchTimelineData({ child, page: 1, filterObj }))
        } catch (error: any) {
            console.log("error in timeline api : ", error.response);
            await dispatch(TimelineActions.resetTimelineState());
        }
    }
);